module.exports = __webpack_public_path__ + "static/img/loading.2e1cb5f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loading.gif
// module id = F7NO
// module chunks = 1